export enum SearchResultType {
  EVICTION = 'EVICTION',
  USER = 'USER',
  INVOICE = 'INVOICE',
  ORGANIZATION = 'ORGANIZATION',
  HELP_ARTICLE = 'HELP_ARTICLE'
}
